/**
 * Send a plan-cancel frame, then dismiss the gate only if that send was
 * accepted. A missing socket or a thrown send leaves `planProposed` and
 * `proposedTodos` unchanged so the user can retry.
 */
export function dispatchPlanCancel(deps: {
  sessionId: string
  sendPlanDecision: (
    decision: "cancel",
    extra?: { targetSessionId?: string | null }
  ) => boolean | void
  setDeepPlanProposed: (sessionId: string, proposed: boolean) => void
}): boolean {
  const accepted = deps.sendPlanDecision("cancel", { targetSessionId: deps.sessionId }) === true
  if (accepted && deps.sessionId) {
    deps.setDeepPlanProposed(deps.sessionId, false)
  }
  return accepted
}
